import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { SvgIconProps } from '@mui/material';
import { IconButton, IconButtonProps } from 'components/IconButton';

interface CloseButtonProps extends Omit<IconButtonProps, 'color' | 'children' | 'background'> {
	background?: boolean;
	color?: SvgIconProps['color'];
}

function CloseButton({ color = 'primary', background, ...props }: CloseButtonProps) {
	return (
		<IconButton background={background && '#FFFFFFB2'} {...props}>
			<CloseIcon color={color} />
		</IconButton>
	);
}

export default CloseButton;
